import {
  Backdrop,
  Box,
  CircularProgress,
  CircularProgressProps as MUICircularProgressProps,
  Typography,
} from '@mui/material';

type CircularProgressBaseProps = Pick<MUICircularProgressProps, 'color'>;
export interface LoadingProps extends CircularProgressBaseProps {
  open: boolean;
  value?: number;
}

export function Loading({ open, color = 'secondary', value }: LoadingProps) {
  return (
    <Backdrop
      sx={theme => ({
        zIndex: theme.zIndex.drawer + theme.zIndex.modal + theme.zIndex.tooltip,
        display: 'inline-flex',
      })}
      open={open}
    >
      <CircularProgress color={color} />
      {value ? (
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption" component="div" color={color}>{`${Math.round(
            value
          )}%`}</Typography>
        </Box>
      ) : (
        <></>
      )}
    </Backdrop>
  );
}

export default Loading;
